import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";
export const saveBathroomLogEntry = async ({
  child,
  user,
  bathroomDate,
  bathroomTimestamp,
  bathroomType,
  location,
  consistency,
  consistencyLabel,
  notes,
  summary,
  bathroomPresentation,
  mode,
  entryId,
  initialData,
}) => {
  const docData = {
    childId: child.id,
    createdBy: user.uid,
    createdAt: serverTimestamp(),
    title: bathroomPresentation.title,
    titlePrefix: bathroomPresentation.titlePrefix,
    text: summary || bathroomPresentation.fallbackText,
    status: "active",
    category: "bathroom",
    categoryLabel: bathroomPresentation.categoryLabel,
    adaptiveBathroomLogLabel: bathroomPresentation.categoryLabel,
    adaptiveBathroomLogLens: bathroomPresentation.lensKey,
    tags: ["bathroom", bathroomType?.toLowerCase()].filter(Boolean),
    timestamp: bathroomTimestamp,
    entryDate: new Date(`${bathroomDate}T00:00:00`).toDateString(),
    authorId: user.uid,
    authorName: user.displayName || user.email?.split("@")[0] || "User",
    authorEmail: user.email,
    source: "bathroom_log",
    notes,
    bathroomDetails: {
      type: bathroomType,
      location,
      consistency: consistency,
      consistencyLabel: consistencyLabel,
      notes,
      adaptiveBathroomLogLabel: bathroomPresentation.categoryLabel,
      adaptiveBathroomLogLens: bathroomPresentation.lensKey,
      adaptiveLocationLabel: bathroomPresentation.locationLabel,
      adaptiveStoolScaleLabel: bathroomPresentation.stoolScaleLabel,
      adaptiveNotesLabel: bathroomPresentation.notesLabel,
    },
  };

  let docRef;
  if (mode === "edit" && (entryId || initialData?.id)) {
    const targetId = entryId || initialData?.id;
    docRef = doc(db, "dailyLogs", targetId);
    await updateDoc(docRef, {
      ...docData,
      updatedAt: serverTimestamp(),
    });
  } else {
    docRef = await addDoc(collection(db, "dailyLogs"), docData);
  }

  return docRef;
};
